/** Keep keyboard focus in the active modal and restore the previous page state. */
export function modalFocus(root: HTMLElement, close: () => void): () => void {
  const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  const restored: Array<[HTMLElement, boolean]> = [];
  for (let node: HTMLElement | null = root; node?.parentElement; node = node.parentElement) {
    for (const sibling of node.parentElement.children) {
      if (sibling !== node && sibling instanceof HTMLElement) {
        restored.push([sibling, sibling.inert]); sibling.inert = true;
      }
    }
  }
  root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.tabIndex = -1;
  const visible = (e: HTMLElement) => e.getClientRects().length > 0 && !e.closest('[hidden], [inert]');
  const keys = (event: KeyboardEvent) => {
    if (event.defaultPrevented) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); return; }
    if (event.key !== 'Tab') return;
    const nested = [...root.querySelectorAll<HTMLElement>('[role="dialog"]')].filter(visible).at(-1);
    const scope = nested ?? root;
    const nodes = [...scope.querySelectorAll<HTMLElement>('button:not(:disabled), a[href], input:not(:disabled), summary, [tabindex="0"]')].filter(visible);
    const first = nodes[0] ?? scope, last = nodes.at(-1) ?? scope;
    if (!scope.contains(document.activeElement) || (event.shiftKey ? document.activeElement === first : document.activeElement === last)) {
      event.preventDefault(); (event.shiftKey ? last : first).focus();
    }
  };
  root.addEventListener('keydown', keys);
  queueMicrotask(() => { if (root.isConnected) root.focus({ preventScroll: true }); });
  return () => {
    root.removeEventListener('keydown', keys);
    for (const [element, inert] of restored) element.inert = inert;
    if (previous?.isConnected) previous.focus({ preventScroll: true });
  };
}
